import styled from 'styled-components';
import { Row } from 'reactstrap';

export const HeaderPage = styled.div`
  display: block;
  background-color: ${props => props.theme.color_white};
  min-height: 64px;
  height: ${props => props.height || 'auto'};
  max-height: none;
  z-index: 2;
  border-bottom: 1px solid rgba(21, 43, 78, 0.08);
  box-shadow: ${props =>
    props.isTab ? 'none' : '0 1px 2px rgba(21, 43, 78, 0.06)'};
  margin-bottom: 12px;

  @media (max-width: 800px) {
    display: none;
  }
`;

export const ContentHeader = styled.div`
  margin: auto;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 0.6rem;

  @media (min-width: 801px) {
    width: 98%;
    min-width: 98%;
  }

  @media (min-width: 1256px) {
    width: 81%;
    min-width: 1177px;
  }

  @media (max-width: 800px) {
    width: 100%;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  @media (min-width: 800px) {
    padding-top: 0.65rem;
  }
`;
export const RowSpacingBetween = styled(Row)`
  margin: 0;
  padding: 0;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
`;

export const SearchContainer = styled.div`
  display: flex;
  height: ${props => props.height ? props.height : '9vh'};
  justify-content: ${props => props.justify || 'space-between'};
  align-items: center;
  flex-direction: row;
  margin-bottom: 2px;

  @media(max-width: 800px){
    display: none;
  }
`;

export const SubtitleHeader = styled.span`
  color: ${props => props.theme.color_gray};
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
`;
